var version = {
    "name":      "dativery",
    "buildDateCode": "20260925-144642",
    "buildDate": "Fri Sep 25 2026 14:46:42 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260925-144642",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;